export default __webpack_public_path__ + "static/media/user1.8619effb.png";